enum AppealStatus {
    Active = 'active',
    Inactive = 'inactive',
}

export { AppealStatus };
